


import React, { useState } from 'react'

import { useTranslation } from 'react-i18next';
import { router, usePage } from '@inertiajs/react';
import { SelectedFiltersType } from '@/types';


import locationlist from "@/assets/locationlist.svg";
import searchbutton from "@/assets/SearchButton.svg";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store/store';

import { setSearchTerm } from '@/store/slices/modalSlice';
import { Button } from "@heroui/react";

const SearchBar = ({ closeFilters }) => {

    const { t } = useTranslation(["glossary"])
    const { selectedFilters, locale }: { selectedFilters: SelectedFiltersType, locale: string } = usePage().props;
    const searchTerm = useSelector((state: RootState) => state.modal.searchTerm)
    const [loading, setLoading] = useState<boolean>(false)
    const dispatch = useDispatch()

    const applyFilters = () => {
        //get scopes params from url
        let scopesParams = new URLSearchParams(document.location.toString());
        console.log('adasdasdas', selectedFilters);

        let scopes = [];
        for (const [key, value] of scopesParams.entries()) {
            if (key.startsWith("searchScope[")) {
                scopes.push({ key, value });
            }
        }
        const params = new URLSearchParams();
        //add scopes params no new
        scopes.forEach((item) => {
            params.append(item.key, item.value);
        });

        if (selectedFilters?.accomodation_types?.length > 0) {
            selectedFilters.accomodation_types.forEach((type: string) => {
                params.append("accomodation_types[]", type);
            });
        }

        if (selectedFilters?.business_types?.length > 0) {
            selectedFilters.business_types.forEach((type: string) => {
                params.append("business_types[]", type);
            });
        }

        if (selectedFilters?.event_types?.length > 0) {
            selectedFilters?.event_types.forEach((type: string) => {
                params.append("event_types[]", type);
            });
        }

        if (selectedFilters?.activity_types?.length > 0) {
            selectedFilters.activity_types.forEach((type: string) => {
                params.append("activity_types[]", type);
            });
        }

        if (selectedFilters?.place_types?.length > 0) {
            selectedFilters?.place_types?.forEach((type: string) => {
                params.append("place_types[]", type);
            });
        }

        if (selectedFilters?.area?.length > 0) {
            selectedFilters.area.forEach((area: string) => {
                params.append("area[]", area);
            });
        }
        if (selectedFilters["check-in"]) params.append("check-in", selectedFilters["check-in"]);
        if (selectedFilters["check-out"]) params.append("check-out", selectedFilters["check-out"]);
        // params.append("adults", selectedFilters.adults);
        // params.append("children", selectedFilters.children);
        if (searchTerm) params.append("name", searchTerm);

        console.log(params.toString());

        router.get(
            `/${locale}/search?${params.toString()}`,
            {},
            {
                preserveState: true,
                onStart: () => {
                    setLoading(true)
                },
                onSuccess: () => {

                },
                onFinish: () => {
                    setLoading(false)
                    closeFilters()
                }
            },
        );
    }

    return (

        <div className="mb-4 w-11/12 mx-auto flex relative ">

            <img
                className="absolute size-8 left-2 top-0 h-full rounded-md flex items-center justify-center"
                src={locationlist}
                alt="search"

            />
            <input
                type="text"
                className="w-full rounded-xl bg-[#DBDBDB]/50 border-none text-black pl-12 pr-28 h-12"
                placeholder={t("search")}
                value={searchTerm}
                onChange={(e) => dispatch(setSearchTerm(e.target.value))}
            />

            <Button
                isLoading={loading}
                disabled={loading}
                isIconOnly
                title="search"
                className="absolute -right-1 top-0 h-full rounded-md  bg-primary text-white"
                onClick={applyFilters}
            >
                <img

                    src={searchbutton}
                    alt="search"

                />
            </Button>

            {searchTerm && <Button

                title='delete'
                onClick={() => dispatch(setSearchTerm(''))}
                className='absolute right-14 top-1 bg-transparent'
                isIconOnly
                startContent={
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                }
            />}

        </div>
    )
}

export default SearchBar